function normalizeCount(value) {
  const count = Number(value);
  return Number.isFinite(count) && count >= 0 ? count : 0;
}

function buildDistributionRows(data, getName) {
  const items = Array.isArray(data) ? data : [];
  const normalized = items.map(item => ({
    name: getName(item) || '未知',
    count: normalizeCount(item.count)
  }));
  const total = normalized.reduce((sum, item) => sum + item.count, 0);

  return normalized.map(item => ({
    ...item,
    percentage: total > 0 ? `${(item.count * 100 / total).toFixed(2)}%` : '0.00%'
  }));
}

function sortDistributionRows(rows, names) {
  const order = new Map(names.map((name, index) => [name, index]));
  return rows.slice().sort((left, right) => {
    const leftIndex = order.has(left.name) ? order.get(left.name) : names.length;
    const rightIndex = order.has(right.name) ? order.get(right.name) : names.length;
    return leftIndex - rightIndex;
  });
}

function buildChartData(rows) {
  return rows.map(item => ({ name: item.name, value: item.count }));
}

function getGenderName(gender) {
  return { '1': '男', '2': '女', '0': '未知' }[String(gender)] || '未知';
}

module.exports = {
  buildDistributionRows,
  buildChartData,
  sortDistributionRows,
  getGenderName
};
